import React, { useEffect } from "react";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";

function Other() {
  const Navigate = useNavigate();

  useEffect(() => {
    Navigate("/126");
  }, []);
  return (
    <Header>
      <div className="student-information-body">
        <div className="row ">
          <div class="col-md-12 text-center event-title pt-4">
            <h2>Error....</h2>
            <h3>
              Please contact the administrator or please add event id on url.
            </h3>
          </div>
        </div>
      </div>
    </Header>
  );
}

export default Other;
